// Loader
// Small class that implements loading behaviour
// First 6 elements that have correspond to `.loader-item.collapsed` gets the `.collapsed` removed.

// Usage
// - loader : on wrapping element
// - loader-item : on items that have to be loaded (use collapsed to hide)
// - loader-button : on the button that enables loading


// Note
// Except for hiding the loader-button, no css is applied, e.g., `.collapsed` css markup have to be implemented

export default class Loader {
    constructor(element) {
        this.element = element;

        this.loaderButton = this.element.querySelector(".loader-button");

        if (this.loaderButton) {
            this.hideButton();

            this.loaderButton.addEventListener("click", (e) => {
                e.preventDefault();
                this.loadElements();
            });

        }

    }

    loadElements() {
        const collapsedElements = this.element.querySelectorAll(".loader-item.collapsed");
        let counter = 1; 
        for (const collapsedElement of collapsedElements) {
            if (counter > 6) return;

            this.showElement(collapsedElement);
            counter++;
        }
        this.hideButton();
    }

    showElement(element) {
        element.classList.remove("collapsed");
    }

    hideButton() {
        const collapsedElements = this.element.querySelectorAll(".loader-item.collapsed");

        if (collapsedElements.length === 0) {
            this.loaderButton.style.display = "none";
        }
    }
}
